<div class="mx-8 mt-20" animate.enter="ease-in-fast" *transloco="let t">
  @if (subscription$ | async; as subscription) {
    @if (learningPlans$ | async; as learningPlansResponse) {
      <app-dashboard-welcome
        [subscription]="subscription"
        [learningPlans]="learningPlansResponse"
      />
    }
  }
</div>
